import type { Meta, StoryObj } from "@storybook/react";

import type { TextProps } from "@/ui/core";
import { Text } from "@/ui/core";
import type { TypographyVariant } from "@/ui/core/Text";
import { VStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

const TypographyVariantValues: Record<TypographyVariant, TypographyVariant> = {
  body: "body",
  bodyMedium: "bodyMedium",
  caption: "caption",
  captionMedium: "captionMedium",
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  overline: "overline",
  overlineMedium: "overlineMedium",
};

const StoryMeta: Meta<TextProps> = {
  title: "Core/Text",
  component: Text,
  argTypes: {
    children: { control: "text" },
    variant: {
      control: "select",
      options: Object.values(TypographyVariantValues),
    },
  },
  args: {
    children: "Welcome to Equip",
  },
};

type Story = StoryObj<TextProps>;

const Body: Story = {};

const Typography: Story = {
  ...StoryMeta,
  render: (args) => {
    const { children } = args;
    return (
      <VStack alignItems="flex-start" flex={1} gap={30} width="100%">
        {Object.values(TypographyVariantValues).map((variant) => (
          <VStack gap={6} key={variant}>
            <Text
              testID={joinTestIDs("story", "text", "variant")}
              variant="captionMedium"
            >
              {variant}:
            </Text>
            <Text
              testID={joinTestIDs("story", "text", "children")}
              variant={variant}
            >
              {children}
            </Text>
          </VStack>
        ))}
      </VStack>
    );
  },
};

export { Body, Typography, TypographyVariantValues };
export default StoryMeta;
